'use client';

import MediaContent from '@/app/(with-metadata)/(main)/media/MediaContent';
import Hero from '../Hero';
import { FITNESS_WORDING_EN } from '@/wording/fitness/FITNESS_WORDING_EN';

export default function MediaOnePage() {
  return (
    <main className='max-w-[1920px] mx-auto overflow-hidden'>
      <Hero tag={FITNESS_WORDING_EN.text_media_1} />
      <MediaContent tag={FITNESS_WORDING_EN.text_media_1} />
    </main>
  );
}
